var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 7.01634C9.37548 7.40232 9.21003 7.7698 8.92093 8.02488L2.42893 13.7477C1.98151 14.1239 1.31619 14.0734 0.930449 13.6339C0.544704 13.1945 0.579625 12.5268 1.0091 12.1302L6.68611 7.126C6.71763 7.09831 6.73571 7.05835 6.73571 7.01634C6.73571 6.97434 6.71763 6.93437 6.68611 6.90668L1.0091 1.90249C0.710268 1.65123 0.570693 1.2575 0.644385 0.873655C0.718077 0.489809 0.993475 0.176068 1.36401 0.0538368C1.73455 -0.0683938 2.14209 0.0200624 2.42893 0.284976L8.9186 6.00605C9.2084 6.26157 9.37463 6.62955 9.375 7.01634Z",
    fill: "#006C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.6b23a7ee55640b5131eef8a247e77158.svg";
export { ForwardRef as ReactComponent };